module.exports = __webpack_public_path__ + "static/img/053.3faf04c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/053.png
// module id = 7jnv
// module chunks = 0